//import {connect, useSelector} from "react-redux";
import React, {useCallback, useMemo, useEffect, useState, useRef} from "react";
import {CAlert, CButton, CCol, CForm, CFormSelect, CInputGroup, CInputGroupText, CRow} from "@coreui/react";

import connect from "react-redux/es/components/connect";
import {Loading} from "../../../../components/common";
import * as o2Api from "../../../../api/api";
import {AgGridReact} from "ag-grid-react";
import StoreListWhere from "../../where/StoreListWhere";
import {useSelector} from "react-redux";
import * as formatter from "../../../../config/formatter";
import dayjs from "dayjs";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";

//import StoreKitchenDetail from "./StoreKitchenDetail";


const StoreKitchen = (props) => {

    const { user } = useSelector((props) => props.account);



    const MainGridRef = useRef();
    const PosGridRef = useRef();
    const PrtGridRef = useRef();
    const gridRef = useRef();

    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const gridStyle = useMemo(() => ({height: 450, width: "100%"}), []);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({visible: false, message: ""});
    const [formData, setFormData] = useState({});

    const [searchForm, setSearchForm] = useState({
        cmpCd: "", brandCd: "", storeCd: "", useYn: ""
    });

	//그리드 row영역 정의
    const [prtListData, setPrtListData] = useState([]);
    const [posListData, setPosListData] = useState([]);
    const [posPrtMapData, setPosPrtMapData] = useState([]);
    const [productData, setProductData] = useState([]);

    //  const [posPrtMapData, setPosPrtMapData] = useState([getManageApplication(1)]);

    const [pos, setPos] = useState([{posCd:""}]);

    const [prtColumnDefs] = useState([

        {field: "seq", headerName: "시퀀스", minWidth: 50, hide: true, cellClass: "static-cell"}, ///hide: true
        {field: "storeCd", headerName: "점포코드", minWidth: 50, hide: true},
        {field: "storeNm", headerName: "점포명", minWidth: 50, cellClass: "static-cell", checkboxSelection: true, headerCheckboxSelection: true},
        {field: "prtNm", headerName: "프린터명", minWidth: 50, cellClass: "static-cell", cellStyle: {color: "blue", cursor: "pointer"}},
        {field: "prtNo", headerName: "프린터번호", minWidth: 80, cellClass: "static-cell"},
        {field: "prtTypeNm", headerName: "연결타입", minWidth: 50, cellClass: "static-cell"},
        {field: "posCd", headerName: "POS번호", minWidth: 50, cellClass: "static-cell"},
        {field: "ip", headerName: "IP", minWidth: 50, cellClass: "static-cell"},
        {field: "port", headerName: "시리얼포트", minWidth: 50, cellClass: "static-cell"},
        {field: "rate", headerName: "포트 속도", minWidth: 50, cellClass: "static-cell"},
        {field: "useYn", headerName: "사용여부", minWidth: 50, cellClass: "static-cell"}
    ]);

    const [posColumnDefs] = useState([
        {field: "cmpCd", headerName: "회원사코드", minWidth: 50, hide: true},
        {field: "brandCd", headerName: "브랜드코드", minWidth: 50, hide: true},
        {field: "posCd", headerName: "POS번호", minWidth: 50, cellClass: "static-cell"},
        {field: "storeCd", headerName: "점포코드", minWidth: 50, hide: true}
    ]);

    const [posPrtMapColumnDefs] = useState([
        {
            field: "prtNo",
            headerName: "프린터번호",
            editable: true,
            //headerCheckboxSelection: true,
            checkboxSelection: true,
            showDisabledCheckboxes: true

        },
        {field: "cmpCd", headerName: "회원사코드", minWidth: 50, hide: true},
        {field: "brandCd", headerName: "브랜드코드", minWidth: 50, hide: true},
        {field: "storeCd", headerName: "점포코드", minWidth: 50, hide: true},
        {field: "posCd", headerName: "POS번호", minWidth: 50, hide: true, cellClass: "number-cell"},
        {field: "prtNm", headerName: "프린터명", minWidth: 50, cellClass: "static-cell"},
        {field: "prtCnt", headerName: "출력매수", minWidth: 50, cellClass: "static-cell", editable: true }
    ]);

    const [productColumnDefs] = useState([
        {field: "seq", headerName: "seq", minWidth: 50, cellClass: "static-cell", hide:true},
        {field: "prtNo", headerName: "프린터번호", minWidth: 80, cellClass: "static-cell", hide:true},
        {field: "cmpCd", headerName: "회원사코드", minWidth: 50, hide: true},
        {field: "brandCd", headerName: "브랜드코드", minWidth: 50, hide: true},
        {field: "storeCd", headerName: "점포코드", minWidth: 50, hide: true},
        {field: "restProductCd", headerName: "상품코드", minWidth: 50, cellClass: "static-cell", checkboxSelection: true},
        {field: "productCd", headerName: "상품코드", minWidth: 50, cellClass: "static-cell", checkboxSelection: true, hide:true},
        {field: "productNm", headerName: "상품명", minWidth: 50, cellClass: "static-cell"}
    ]);


    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };


    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    //3.연결 프린터 신규 추가
    const setNewPrtMap = () => {
        const posCd = pos.posCd;
        if(posCd === null || posCd === undefined){
            alert("[2.포스 번호]를 먼저 선택해주세요.");
            return false;
        }

        const newData = {
            cmpCd: props.cmpCd,
            brandCd: props.brandCd,
            storeCd: props.storeCd,
            posCd: posCd,
            prtNo: "",
            prtCnt: 1,
            useYn: "Y",
            instUser: user.userId,
            updUser: user.userId
        };
        setPosPrtMapData((state) => {
            return [...state, newData];
        });
    };
    //3. 연결 프린터 저장
    const savePrtMap = (useYn, e) => {

        const {cmpCd, brandCd, storeCd} = props.selected;
        //console.log(">>>>>> search() ", cmpCd, brandCd, storeCd);

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            useYn: useYn

        };

        const { api } = PrtGridRef.current;
        if (api === null) return;

        if (confirm("연결 프린터를 저장하시겠습니까?")) {

            const selectRows = api.getSelectedRows();

            if (selectRows.length > 0) {
                selectRows.map((item) => {

                    item.cmpCd = cmpCd;
                    item.brandCd = brandCd;
                    item.storeCd = storeCd;
                    item.useYn = useYn;
                    item.instUser = user.userId;
                    item.updUser = user.userId;


                    if (item.prtNo.length === 0) {
                        alert("프린터 번호는 필수로 입력하셔야 합니다.");
                        return;
                    }
                });
            } else {
                return;
            }
            setLoading(true);
            console.log("저장 전 selectRows ::: ", selectRows);

            try {
                o2Api.putPosPrtMap(selectRows).then((result) => {
                    const { responseBody, responseCode, responseMessage } = result.data;
                    if (responseCode === "200") {
                        // 성공
                        alert("처리되었습니다.");
                        getPosPrtMap(selectRows[0]);

                    } else {

                    }
                });
            } catch (e) {
                console.error(e.message);
            } finally {
                setLoading(false);
            }
        }


    };

    //상품등록 클릭
    const openProductForm = (e) => {

        const {cmpCd, brandCd, storeCd} = props.selected;
        const { api } = PrtGridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        if(selectRows.length == 0) {
            alert("[3.포스 연결 프린터] 목록을 먼저 선택해 주세요.");
            return;

        }

        const params = "cmpCd=" + cmpCd + "&brandCd=" + brandCd + "&storeCd=" + storeCd+ "&prtNo="+selectRows[0].prtNo+"&userId="+user.userId;
        console.log("params :: " , params);

        //리액트 콜백 처리 // callback
        const popup = window.open("/#/product/PopupProductForm?"+ params, "", "width=1200, height=800");
        popup.addEventListener('beforeunload', function() {
            getStoreKitchenProduct(selectRows[0]);
        })

    };

    const updateKitchenProduct = (e) => {

        const {cmpCd, brandCd, storeCd} = props.selected;


        const { api } = gridRef.current;
        console.log("api :: " , api);
        if (api === null) return;


        if (confirm("주방 상품을 삭제하시겠습니까?")) {

            const selectRows = api.getSelectedRows();

            if (selectRows.length > 0) {
                selectRows.map((item) => {

                    item.cmpCd = cmpCd;
                    item.brandCd = brandCd;
                    item.storeCd = storeCd;
                    item.productCd = item.productCd;
                    item.useYn = 'N';
                    item.instUser = user.userId;
                    item.updUser = user.userId;


                });
            } else {
                return;
            }
            setLoading(true);

            console.log("상품 삭제 전 selectRows ::: ", selectRows);

            try {
                o2Api.putStorePrtProduct(selectRows).then((result) => {
                    const { responseBody, responseCode, responseMessage } = result.data;
                    if (responseCode === "200") {
                        // 성공
                        alert("처리되었습니다.");
                        getStoreKitchenProduct(selectRows[0]);


                    } else {

                    }
                });
            } catch (e) {
                console.error(e.message);
            } finally {
                setLoading(false);
            }
        }

    }



    //주방프린터 신규등록 클릭
    const openKitchenPrtForm = (e) => {
        const {cmpCd, brandCd, storeCd, useYn} = props.selected;

        //일단
        const params = "cmpCd=" + cmpCd + "&brandCd=" + brandCd + "&storeCd=" + storeCd+"&userId="+user.userId

        console.log("params :: " , params);

        const popup = window.open("/#/store/kitchen/PopupKitchenPrtForm?"+ params, "", "width=800, height=600");
        popup.addEventListener('beforeunload', function() {
            search();
        })
    };


    //1.주방 프린터 목록 삭제
    const delStoreKitchenPrt = (useYn, e) => {

        const {cmpCd, brandCd, storeCd} = props.selected;

        const { api } = MainGridRef.current;
        console.log("api :: " , api);
        if (api === null) return;

        if (confirm("프린터 정보를 삭제하시겠습니까?")) {

            const selectRows = api.getSelectedRows();

            if (selectRows.length > 0) {
                selectRows.map((item) => {
                    item.cmpCd = cmpCd;
                    item.brandCd = brandCd;
                    item.storeCd = storeCd;
                    item.useYn = useYn;
                    item.instUser = user.userId;
                    item.updUser = user.userId;
                });
            } else {
                return;
            }
            setLoading(true);

            console.log("프린터 삭제 전 selectRows ::: ", selectRows);

            try {
                o2Api.delStoreKitchenPrt(selectRows).then((result) => {
                    const { responseBody, responseCode, responseMessage } = result.data;
                    if (responseCode === "200") {
                        // 성공
                        alert("처리되었습니다.");
                        search();
                    }
                });
            } catch (e) {
                console.error(e.message);
            } finally {
                setLoading(false);
            }
        }


    };


    //조회(1.프린터 목록)
    const search = () => {
        const {cmpCd, brandCd, storeCd} = props.selected;
        console.log(">>>>>> search() : ", cmpCd, brandCd, storeCd);

        if(storeCd === ""){
            alert("점포를 선택해 주세요.");
            return false;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            useYn : formData.useYn
        };
        console.log("params :: " , params);

        setLoading(true);
        o2Api.getPrtList(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log("prtList :: ", responseBody);
                setLoading(false);
                //다른 그리드 초기화 먼저함
                setPosPrtMapData(null);
                setProductData(null);
                //실제 조회결과 그리드 결과 값 Setting
                setPrtListData(responseBody);
                getStoreDeviceInfo();
            }
        });
    }; //search 종료

    //(2.POS목록)
    const getStoreDeviceInfo = async () => {

        const {cmpCd, brandCd, storeCd} = props.selected;
        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            //userId: user.userId,
            storeCd: storeCd,
            useYn : "Y"
        };
        console.log("pos목록 params :: " , params);
        setLoading(true);

        o2Api.getStoreDeviceInfo(params).then((result) => {
            const {responseBody, responseCode, responseMessage} = result.data;
            if (responseCode === "200") {
                console.log("responseBody ::: " , responseBody);
                setLoading(false);
                setPosListData(responseBody);
            }
        });
    };


    const onRowStorePrtClick = useCallback((e) => {
        if (!e.node.selected)
            return;
    }, []);

    const onCellClicked = (e) => {

        console.log("e.colDef.field:: ", e.colDef.field);

        const {cmpCd, brandCd, storeCd} = props.selected;
        const { api } = MainGridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        if(selectRows.length == 0) {
            alert("[3.포스 연결 프린터] 목록을 먼저 선택해 주세요.");
            return;
        }

        switch (e.colDef.field) {
            case "prtNm":
                const params = "cmpCd=" + cmpCd + "&brandCd=" + brandCd + "&storeCd=" + storeCd+"&userId="+user.userId + "&seq="+selectRows[0].seq;

                const popup = window.open("/#/store/kitchen/PopupKitchenPrtForm?"+ params, "", "width=800, height=600");
                popup.addEventListener('beforeunload', function() {
                    search();
                });

                break;
        }
    };


    //3. prt매핑 정보 조회
    const onRowPosListClick = useCallback((e) => {
        console.log("포스목록 클릭 :: ", e);

        if (!e.node.selected)
            return;

        pos.posCd = e.data.posCd;
        getPosPrtMap(e.data);
    }, []);

    const getPosPrtMap = (form) => {

        setProductData();
        setPosPrtMapData();

        setError({
            visible: false,
            message: ""
        });
        const { api } = PosGridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();
        console.log("selectRows :: ", selectRows);

        const params = {
            cmpCd: selectRows[0].cmpCd,
            brandCd: selectRows[0].brandCd,
            storeCd: selectRows[0].storeCd,
            posCd: form.posCd,
            useYn: 'Y'
        };
        console.log("params :: ", params);

        if(params.storeCd === ""){
            alert("점포를 선택해 주세요.");
            return false;
        }

        setLoading(true);
        try {
            o2Api.getPosPrtMap(params).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    setPosPrtMapData(responseBody);

                    console.log(">>> response :: ", responseBody);
                }
            });
        }
        catch (e) {
            console.log(">>> error :: ", e);
        }
        finally {
            setLoading(false);
        }
    }

    //4.주방 프린터 (등록된)상품 조회
    const onRowPosPrtMapClick = useCallback((e) => {
        if (!e.node.selected)
            return;
        setProductData();
        getStoreKitchenProduct(e.data);
    }, []);

    const getStoreKitchenProduct = (form) => {
        //console.log(">>>>>>>>>>>> form.prtNo :: ", form.prtNo);
        setError({
            visible: false,
            message: ""
        });
        const {cmpCd, brandCd, storeCd} = props.selected;
        const { api } = PrtGridRef.current;
        if (api === null) return;
        const selectRows = api.getSelectedRows();

        const params = {
            cmpCd: selectRows[0].cmpCd,
            brandCd: selectRows[0].brandCd,
            storeCd: selectRows[0].storeCd,
            prtNo: form.prtNo
        };
        console.log("params :: ", params);

        if(params.storeCd === "" || params.storeCd === undefined){
            return;
        }

        setLoading(true);
        try {
            o2Api.getStoreKitchenProduct(params).then((result) => {
                const {responseBody, responseCode, responseMessage} = result.data;
                if (responseCode === "200") {
                    setProductData(responseBody);

                    console.log(">>> response :: ", responseBody);
                }
            });
        }
        catch (e) {
            console.log(">>> error :: ", e);
        }
        finally {
            setLoading(false);
        }
    }


    //저장
    const save = async () => { //save시작
        setError({visible: false, message: ""});
        if (confirm("저장하시겠습니까?")) {
            const StoreKitchen = {
                ...selectedStoreKitchen,
                cmpCd: selectedStoreKitchen.cmpCd ? selectedStoreKitchen.cmpCd : user.cmpCd,
                brandCd: selectedStoreKitchen.brandCd ? selectedStoreKitchen.brandCd : user.brandCd,
                instUser: selectedStoreKitchen.instUser ? selectedStoreKitchen.instUser : user.userId,
                updUser: user.userId,
            }
            setLoading(true);

            try {
                //const {data: result} = await api.putProduct(product);
                const {data: result} = await api.putStoreDevice(StoreKitchen);
                const {responseBody, responseCode, responseMessage} = result;
                if (responseCode === "200") {
                    // 성공
                    alert("정상적으로 처리되었습니다.");
                    search();
                } else {
                    setError({visible: true, message: responseMessage});
                }
            } catch (e) {
                setError({visible: true, message: e.message});
            } finally {
                setLoading(false);
            }
        }
    } //save 종료


    const onGridReady = useCallback((params) => {
        MainGridRef.current.api.sizeColumnsToFit();
        PosGridRef.current.api.sizeColumnsToFit();
        PrtGridRef.current.api.sizeColumnsToFit();
    }, [])
    ;



    //-------화면 Grid 영역 시작----------------------------------------------
    return (
        <div>
            {error.visible ? <CAlert color="danger" dismissible={true}>{error.message}</CAlert> : null}
            {loading ? <Loading/> : null}


            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>주방프린터 설정관리</h5>
                <div>
                    <CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
                </div>
            </div>

            <CForm className={"row row-cols-lg-auto g-1 align-items-center"}>
                <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                                onSelect={(c, v) => handleSelect(c, v)}/>

                <CCol xs={12}>
                <CInputGroup size={"sm"} >
                    <CInputGroupText style={{ width: 80 }}>사용유무</CInputGroupText>
                    <CFormSelect id="useYn"
                                 onChange={(e) => {
                                     setFormData((state) => ({
                                         ...state,
                                         useYn: e.target.value
                                     }));
                                 }}
                    >
                        <option value={""}>전체</option>
                        <option value={"Y"}>사용</option>
                        <option value={"N"}>미사용</option>
                    </CFormSelect>
                </CInputGroup>
				</CCol>
            </CForm>  {/*조회영역 종료*/}
            <div style={{height: 10}}/>
			{/*하단 그리드 영역*/}
            <CRow>
				<CCol xs={12}>
					{/*
                    <CButton color={"primary"} style={{width: "100%", height: 35, textAlign: "start"}} size={"sm"} disabled={true}>1.프린터 목록</CButton>
					*/}
                    <div className="d-grid gap-1 d-md-flex " style={{ marginBottom: 10 }}>
                        <h5>1.프린터 목록</h5>
                        <span style={{paddingLeft: 15}}>
                        <CButton size={"sm"} color="primary" onClick={openKitchenPrtForm} style={{marginRight: 5}}>신규등록</CButton>
                        <CButton size={"sm"} color="primary" onClick={(e)=>{delStoreKitchenPrt("N", e)}}style={{ marginRight: 5 }}>삭제</CButton>
                        </span>
                    </div>
                    <CRow>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 250}}>
                            <AgGridReact
                                ref={MainGridRef}
                                onGridReady={onGridReady}
                                rowSelection={"single"}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={prtListData}
                                animateRows={true}
                                onRowSelected={onRowStorePrtClick}
                                defaultColDef={defaultColDef}
                                columnDefs={prtColumnDefs}
                                onCellClicked={onCellClicked}
                                rowSelection="multiple">
                            </AgGridReact>
                        </div>
					</CRow>
				</CCol>
            </CRow>

            <div style={{height: 20}}/>

            <CRow>
                <CCol xs={2}>
                    {/*
                    <CButton color={"primary"} style={{width: "100%", height: 35, textAlign: "start"}} size={"sm"} disabled={true}>2.포스 목록</CButton>
                    */}
                    <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                        <h5>2.포스 목록</h5>
                    </div>

                    <div className="ag-theme-alpine" style={{width: "100%", height: 250}}>
                    <AgGridReact
                        ref={PosGridRef}
                        onGridReady={onGridReady}
                        rowSelection={"single"}
                        headerHeight={30}
                        rowHeight={30}
                        rowData={posListData}
                        animateRows={true}
                        onRowClicked={onRowPosListClick}
                        defaultColDef={defaultColDef}
                        columnDefs={posColumnDefs}>
                    </AgGridReact>
                </div>
				</CCol>

                <CCol xs={4}>
                    {/*
                    <CButton color={"primary"} style={{width: "100%", height: 35, textAlign: "start"}} size={"sm"} disabled={true}>3.포스 연결프린터</CButton>
                    */}
                    <div className="d-grid gap-1 d-md-flex " style={{ marginBottom: 10 }}>
                        <h5>3.포스 연결프린터</h5>
                        <span style={{paddingLeft: 15}}>
                        <CButton size={"sm"} color="primary" onClick={setNewPrtMap} style={{marginRight: 5}}>신규</CButton>
                        <CButton size={"sm"} color="primary" onClick={(e)=>{savePrtMap("Y", e)}} style={{ marginRight: 5 }}>저장</CButton>
                        <CButton size={"sm"} color="primary" onClick={(e)=>{savePrtMap("N", e)}}style={{ marginRight: 5 }}>삭제</CButton>
                        </span>
                    </div>
                     <div className="ag-theme-alpine" style={{width: "100%", height: 250}}>
                        <AgGridReact
                            ref={PrtGridRef}
                            onGridReady={onGridReady}
                            rowSelection={"single"}
                            headerHeight={30}
                            rowHeight={30}
                            rowData={posPrtMapData}
                            animateRows={true}
                            onRowClicked={onRowPosPrtMapClick}
                            defaultColDef={defaultColDef}
                            columnDefs={posPrtMapColumnDefs}
                            rowSelection="multiple">
                        </AgGridReact>
                    </div>
                </CCol>

                <CCol xs={6}>
                    <div className="d-grid gap-1 d-md-flex justify-content-between" style={{ marginBottom: 10 }}>
                        <h5>4.상품등록</h5>
                        <span style={{paddingLeft: 15}}>
                            <CButton size={"sm"} color="primary" onClick={openProductForm} >상품등록</CButton> &nbsp;
                            <CButton size={"sm"} color="primary" onClick={(e)=>{updateKitchenProduct(e)}}style={{ marginRight: 5 }}>삭제</CButton>
                        </span>
                    </div>
                    <div className="ag-theme-alpine" style={{width: "100%", height: 250}}>
                        <AgGridReact
                            ref={gridRef}
                            onGridReady={onGridReady}
                            headerHeight={30}
                            rowHeight={30}
                            rowData={productData}
                            animateRows={true}
                            defaultColDef={defaultColDef}
                            columnDefs={productColumnDefs}
                            rowSelection="multiple"
                        >
                        </AgGridReact>
                    </div>
                </CCol>

            </CRow>  {/*2.포스목록 그리드 종료*/}


        </div>  //전체div 종료


    );


};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};
export default connect(mapStateToProps, null)(StoreKitchen);
